import { Outlet } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { Suspense } from 'react'
import Navbar from './components/Navbar.js'
import { useTheme } from './hooks/useTheme.js'
import { useAuth } from './hooks/useAuth.js'
import './i18n.js'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime:  30_000,
      retry:      1,
    },
  },
})

function AppInner() {
  const { theme, toggleTheme } = useTheme()
  const { user } = useAuth()

  /* Logged-in users get the AppShell via the router layout route — no Navbar needed */
  if (user) {
    return <Outlet />
  }

  /* Logged-out: show Navbar (landing, auth, pricing, legal pages) */
  return (
    <>
      <Navbar
        theme={theme}
        onToggleTheme={toggleTheme}
      />
      <main className="min-h-screen pt-16">
        <Suspense fallback={null}>
          <Outlet />
        </Suspense>
      </main>
    </>
  )
}

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AppInner />
    </QueryClientProvider>
  )
}
